import { createAction, props } from '@ngrx/store';

export const registerRequiredRequests = createAction(
  '[App Init] Register Required Requests',
  props<{ requestKeys: string[] }>()
);

export const markRequestComplete = createAction(
  '[App Init] Mark Request Complete',
  props<{ requestKey: string }>()
);

export const markRequestFailed = createAction(
  '[App Init] Mark Request Failed',
  props<{ requestKey: string }>()
);

export const resetAppInit = createAction('[App Init] Reset');

